var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mynavs"},_vm._l((_vm.nav),function(v,i){return _c('div',{staticClass:"btn df hao",class:{ cur: _vm.page==v.pagename },on:{"click":function($event){return _vm.tapNav(v.page,v.pagename)}}},[_c('em',{class:v.icon}),_vm._v(_vm._s(v.name)),(v.type=='notice'&&_vm.$store.state.noticeNoread>0)?_c('i'):_vm._e()])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cba1c3cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mynavs/mynavs.vue
// module id = null
// module chunks = 